export const AUTH_REQUEST = "auth/AUTH_REQUEST";

export const AUTH_SUCCESS = "auth/AUTH_SUCCESS";
export function authSuccess() {
  return {
    type: AUTH_SUCCESS,
  };
}

export const AUTH_FAILURE = "auth/AUTH_FAILURE";
export function authFailure(error) {
  return {
    type: AUTH_FAILURE,
    payload: {
      error,
    },
  };
}

export const CHANGE_USERNAME = "auth/CHANGE_USERNAME";
export function changeUsername(username) {
  return {
    type: CHANGE_USERNAME,
    payload: {
      username,
    },
  };
}

export const CHANGE_PASSWORD = "auth/CHANGE_PASSWORD";
export function changePassword(password) {
  return {
    type: CHANGE_PASSWORD,
    payload: {
      password,
    },
  };
}

export const SIGN_IN = "auth/SIGN_IN";
export function signIn() {
  return {
    type: SIGN_IN,
  };
}

export const SIGN_OUT = "auth/SIGN_OUT";
export function signOut() {
  return {
    type: SIGN_OUT,
  };
}

export const CREATING_USER = "auth/CREATING_USER";
export function creatingUser() {
  return {
    type: CREATING_USER,
  };
}
